import styled from 'styled-components';
import { tableStyle } from '../../AssistantMessageList/styles';
export const MarkdownWrapper = styled.div `
  ${tableStyle}
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;

  > * {
    min-width: 0;
    max-width: 100%;
  }
`;
export const getMarkdownPreStyle = (theme) => ({
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.md,
    padding: theme.spacing.sm,
});
export const markdownCodeStyle = {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
};
export const markdownLinkProps = {
    target: '_blank',
    rel: 'nofollow noreferrer noopener',
};
